
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/customer-support",
      function () {
        return require("private-next-pages/solutions/customer-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/customer-support"])
      });
    }
  